import { ProductImage } from "scrivito/Objs/Product/Components/ProductImage"
import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { PRODUCT_CONFIGURATION_OVERLAY } from "shared/context/overlay/types"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"
import { ProductConfiguratorMode } from "shared/types/ProductConfiguratorMode"

import { useExternalDimensioningModelAvailability } from "entities/products/model/useExternalDimensioningModelAvailability"
import { useProductConfigurationModelAvailability } from "entities/products/model/useProductConfigurationModelAvailability"
import { useProductObjLoad } from "entities/products/model/useProductObjLoad"

import { ProductConfiguratorModeSelectOverlayModel } from "../ProductConfiguratorModeSelectOverlay"
import { ProductConfiguratorModeSelectOverlayConnectorProps } from "../ProductConfiguratorModeSelectOverlayConnector"

export function useProductConfiguratorModeSelectOverlayModel({
  payload: { productType, onProductConfigurationChange }
}: ProductConfiguratorModeSelectOverlayConnectorProps): ProductConfiguratorModeSelectOverlayModel {
  const { closeOverlay } = useCurrentOverlay()
  const { openOverlay } = useOverlay(PRODUCT_CONFIGURATION_OVERLAY)
  const { title, productObj, highestMatchingProductBaseVariantObj } =
    useProductObjLoad(productType)

  const { isConfigurationAvailable } =
    useProductConfigurationModelAvailability(productType)

  const { isExternalDimensioningAvailable } =
    useExternalDimensioningModelAvailability(productType)

  const handleConfiguratorModeSelect = useEvent(
    (mode: ProductConfiguratorMode) => {
      openOverlay({
        configuration: { variantKey: productType },
        mode,
        onSubmit: onProductConfigurationChange
      })
      closeOverlay()
    }
  )

  const handleConfigurationSelect = useEvent(() => {
    handleConfiguratorModeSelect(ProductConfiguratorMode.CONFIGURATION)
  })

  const handleDimensioningSelect = useEvent(() => {
    handleConfiguratorModeSelect(ProductConfiguratorMode.DIMENSIONING)
  })

  return {
    title: title || productType,
    image: (
      <ProductImage
        obj={highestMatchingProductBaseVariantObj || productObj}
        isLoading={!productObj}
      />
    ),
    isConfigurationAvailable,
    isExternalDimensioningAvailable,
    onConfigurationSelect: handleConfigurationSelect,
    onDimensioningSelect: handleDimensioningSelect,
    closeOverlay
  }
}
